<div class="mobile-detail-header">
  <button class="back-btn" (click)="onBack()" aria-label="Go back">
    <i class="pi pi-arrow-left"></i>
  </button>
  <h2 class="mobile-detail-header__title">{{ title }}</h2>
  <button
    *ngIf="showAdd"
    [disabled]="addDisabled"
    (click)="onAdd()"
    class="action-btn"
    aria-label="Add"
  >
    <i class="pi pi-plus"></i>
  </button>
  <button
    *ngIf="showDownload && !showAdd"
    [disabled]="downloadDisabled"
    (click)="onDownload()"
    class="action-btn"
    aria-label="Download"
  >
    <span class="icon download"></span>
  </button>
  <div *ngIf="!showDownload && !showAdd" class="action-btn-placeholder"></div>
</div>
